import {connect} from 'react-redux'
import Bezahlen from "../../../components/views/liga/Bezahlen";

const mapStateToProps = function (state, ownProps) {
    return {userId: state.user.id};
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Bezahlen)